module.exports = __webpack_public_path__ + "img/a123-7.1622d9b0.webp";